// Supabase side of the data layer: the sync transport used by packages/local,
// typed tenant RPCs, and an online-only Repository.
import { createClient, type SupabaseClient } from '@supabase/supabase-js'

export { toSyncError, unwrap } from './errors.ts'
export { SupabaseTransport } from './transport.ts'
export { RemoteRepository } from './repository.ts'
export {
  tenantApi,
  type BusinessLimit,
  type MemberRole,
  type SharedInvoice,
  type SyncRejection,
  type TenantApi,
  type TenantMembership,
} from './rpc.ts'
export type { SupabaseClient }

/** Creates the app's Supabase client (publishable key only, never the secret key). */
export function createSupabase(
  url: string,
  publishableKey: string,
  options: { persistSession?: boolean } = {},
) {
  return createClient(url, publishableKey, {
    auth: { persistSession: options.persistSession ?? true, autoRefreshToken: true },
  })
}
